import { createContext, useContext, type ReactNode } from 'react'

export type ToastTone = 'success' | 'error' | 'info'

export interface ToastItem {
  id: number
  tone: ToastTone
  message: ReactNode
  /** ms; errors stay longer. */
  duration: number
}

export interface ToastApi {
  success: (message: ReactNode, opts?: { duration?: number }) => void
  error: (message: ReactNode, opts?: { duration?: number }) => void
  info: (message: ReactNode, opts?: { duration?: number }) => void
  dismiss: (id: number) => void
}

export const ToastContext = createContext<ToastApi | null>(null)

export function useToast(): ToastApi {
  const ctx = useContext(ToastContext)
  if (!ctx) throw new Error('useToast must be used inside <ToastProvider>')
  return ctx
}
